// src/contexts/TokenContext.js
import React, { createContext, useEffect, useState } from "react";
import { requestsClient } from "../utils/RequestsClients";
import NotFoundPage from "../components/NotFoundPage";

export const TokenContext = createContext({
	appId: null,
	setAppId: () => {},
	pathId: null,
	setPathId: () => {},
	creator: null,
	setCreator: () => {},
	loading: true,
	isMenuRoute: false,
});

/*const RELOAD_BEFORE_EXPIRY_MS = 60 * 1000; // 1 min antes de expirar

function getContextTokenExp(token) {
	try {
		const parts = String(token).split(".");
		if (parts.length < 2) return null;
		const payloadB64 = parts[0].replace(/-/g, "+").replace(/_/g, "/");
		const payload = JSON.parse(atob(payloadB64));
		return payload?.exp ? payload.exp * 1000 : null;
	} catch {
		return null;
	}
}*/

export const TokenProvider = ({ children }) => {
	const [loading, setLoading] = useState(true);
	const [appId, setAppId] = useState(null); // true on local
	const [pathId, setPathId] = useState(true);
	const [creator, setCreator] = useState(null);
	const [isMenuRoute, setIsMenuRoute] = useState(false);

	// Recargar antes de que expire el token para obtener uno nuevo
	/*useEffect(() => {
		const token =
			typeof window !== "undefined" ? window.__APPLABY_CONTEXT__ : null;
		if (!token) return;

		const expMs = getContextTokenExp(token);
		if (!expMs) return;

		const reloadAt = expMs - RELOAD_BEFORE_EXPIRY_MS;
		const delay = Math.max(0, reloadAt - Date.now());

		const t = setTimeout(() => {
			window.location.reload();
		}, delay);

		return () => clearTimeout(t);
	}, []);*/

	const getWebTemplate = (data) => {
		const params = new URLSearchParams(window.location.search);
		const templateParam = params.get("template");

		// Comprueba si existe y es un número entre 1 y 18
		if (templateParam && /^(?:[1-9]|1[0-8])$/.test(templateParam)) {
			data.webTemplate = `restaurant${templateParam}`;
		}

		return data;
	};

	useEffect(() => {
		const getAppId = async () => {
			try {
				const path = window.location.pathname.split("/");
				const firstSegment = path.length > 1 ? path[1] : null;
				const secondSegment = path.length > 2 ? path[2] : null;

				// Detectar si es ruta de menú: /:path/menu
				if (firstSegment === "menu" || (secondSegment === "menu" && firstSegment)) {
					const slug = firstSegment;
					console.log("🔍 Detectada ruta de menú:", slug);
					setIsMenuRoute(true);

					// Obtener creator por slug
					try {
						const iframeCreator = await requestsClient.get(
							"iframe-creator",
							{
								params: firstSegment ? {
									path: firstSegment ?? "domain",
								} : {},
							},
							undefined,
							firstSegment || "domain"
						);
						iframeCreator.data = getWebTemplate(iframeCreator.data);

						const appIdFromCreator = iframeCreator.data.appId;
						console.log("✅ Creator cargado, appId:", appIdFromCreator);

						// Verificar que el menú esté habilitado
						const platformSettingsRes = await requestsClient.get(
							"platformSettings",
							{
								params: { appId: appIdFromCreator },
							},
							undefined,
							firstSegment || "domain"
						);
						const menuEnabled =
							platformSettingsRes?.data?.settings?.menuEnabled;
						console.log("📋 Menú habilitado:", menuEnabled);

						if (!menuEnabled) {
							// Si el menú no está habilitado, mostrar NotFoundPage
							console.log("❌ Menú no habilitado, mostrando NotFoundPage");
							setIsMenuRoute(false);
							setAppId(null);
							setPathId(null);
							setCreator(null);
							setLoading(false);
							return;
						}

						console.log("✅ Configurando datos del menú");
						setCreator(iframeCreator.data);
						setPathId(iframeCreator.data.path);
						setAppId(appIdFromCreator);
						document.querySelector("html").style.backgroundColor =
							iframeCreator.data.backgroundColor;
						setLoading(false);
						return;
					} catch (error) {
						console.error("❌ Error cargando menú:", error);
						// Si hay error, mostrar NotFoundPage
						setIsMenuRoute(false);
						setAppId(null);
						setPathId(null);
						setCreator(null);
						setLoading(false);
						return;
					}
				}

				const pathId = firstSegment;

				if (
					pathId &&
					/^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(
						pathId
					)
				) {
					setAppId(pathId);
				} else {
					const iframeCreator = await requestsClient.get(
						"iframe-creator",
						{
							params: pathId ? {
								path: pathId ?? "domain",
							} : {},
						},
						undefined,
						pathId || "domain"
					);
					iframeCreator.data = getWebTemplate(iframeCreator.data);
					setCreator(iframeCreator.data);
					setPathId(iframeCreator.data.path);
					setAppId(iframeCreator.data.appId);
					document.querySelector("html").style.backgroundColor =
						iframeCreator.data.backgroundColor;
				}
			} catch (error) {
				console.error(error);
			}
			setLoading(false);
		};

		getAppId();
	}, []);

	return (
		<TokenContext.Provider value={{ appId, pathId, creator, isMenuRoute }}>
			{loading ? null : appId ? children : <NotFoundPage />}
		</TokenContext.Provider>
	);
};
